import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type CurrencyBlockchainPair = {
  idCurrency: number;
  idBlockchain: number;
};

// Базовый тип для create/update операций валют-блокчейнов
type CurrencyBlockchainCreateUpdateData = CurrencyBlockchainPair & {
  contract: string;
  main: boolean;
};

// Типы для WebSocket сообщений компонента currencyBlockchains
type CurrencyBlockchainListMessage = WebSocketMessageWithFields<'currency-blockchain', {
  currencyBlockchains: unknown[];
}>;
type CurrencyBlockchainCreateMessage = WebSocketMessageWithFields<'currency-blockchain-create' | 'currency-blockchain-create-success', CurrencyBlockchainCreateUpdateData>;
type CurrencyBlockchainUpdateMessage = WebSocketMessageWithFields<'currency-blockchain-update' | 'currency-blockchain-update-success', CurrencyBlockchainCreateUpdateData>;

type CurrencyBlockchainDeleteMessage = WebSocketMessageWithFields<'currency-blockchain-delete' | 'currency-blockchain-delete-success', CurrencyBlockchainPair>;
type CurrencyBlockchainLockMessage = WebSocketMessageWithFields<'currency-blockchain-lock' | 'currency-blockchain-lock-success', CurrencyBlockchainPair>;
type CurrencyBlockchainUnlockMessage = WebSocketMessageWithFields<'currency-blockchain-unlock' | 'currency-blockchain-unlock-success', CurrencyBlockchainPair>;

// Объединенный тип для всех сообщений
type CurrencyBlockchainsWebSocketMessage = 
  | CurrencyBlockchainListMessage 
  | CurrencyBlockchainCreateMessage 
  | CurrencyBlockchainUpdateMessage 
  | CurrencyBlockchainDeleteMessage 
  | CurrencyBlockchainLockMessage 
  | CurrencyBlockchainUnlockMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataCurrencyBlockchains',
},
  __name: 'currencyBlockchains',
  setup(__props) {

const store = useStore<RootState>();



// Базовый тип для сообщений с валютой и блокчейном
const handleWebSocketMessage = (data: CurrencyBlockchainsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'currency-blockchain':
      store.dispatch('currencyBlockchains/wsCurrencyBlockchains', {currencyBlockchains: data.currencyBlockchains});
      break;

    case 'currency-blockchain-create':
    case 'currency-blockchain-create-success':
      store.dispatch('currencyBlockchains/wsCurrencyBlockchainsCreate', {
        idCurrency: data.idCurrency,
        idBlockchain: data.idBlockchain,
        contract: data.contract,
        main: data.main,
      });
      break;

    case 'currency-blockchain-update':
    case 'currency-blockchain-update-success':
      store.dispatch('currencyBlockchains/wsCurrencyBlockchainsUpdate', {
        idCurrency: data.idCurrency,
        idBlockchain: data.idBlockchain,
        contract: data.contract,
        main: data.main,
      });
      break;

    case 'currency-blockchain-delete':
    case 'currency-blockchain-delete-success':
      store.dispatch('currencyBlockchains/wsCurrencyBlockchainsDelete', {
        idCurrency: data.idCurrency,
        idBlockchain: data.idBlockchain,
      });
      break;

    case 'currency-blockchain-lock':
    case 'currency-blockchain-lock-success':
      store.dispatch('currencyBlockchains/wsCurrencyBlockchainsLock', {
        idCurrency: data.idCurrency,
        idBlockchain: data.idBlockchain,
      });
      break;
    case 'currency-blockchain-unlock':
    case 'currency-blockchain-unlock-success':
      store.dispatch('currencyBlockchains/wsCurrencyBlockchainsUnlock', {
        idCurrency: data.idCurrency,
        idBlockchain: data.idBlockchain,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})